import { Label, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import { Container } from '../Container';
import { SIZE_8 } from '../../constants/sizes';
import { ELabelType, ICardLabel } from '../../types/newbuilding';

interface ICardLabelListProps {
  labels: ICardLabel[] | null;
}

const LABEL_TO_BACKGROUND_COLOR: Record<ELabelType, string> = {
  [ELabelType.PromoExclusive]: 'linear-gradient(90deg, black 0%, #0766fc 100%)',
  [ELabelType.BlackFridayPromo]: 'primary_100',
};

const LABEL_TO_COLOR: Record<ELabelType, string> = {
  [ELabelType.PromoExclusive]: 'white_100',
  [ELabelType.BlackFridayPromo]: 'white_100',
};

export const CardLabelList: React.FC<ICardLabelListProps> = ({ labels }) => {
  if (!labels) {
    return null;
  }

  return (
    <Container display="flex" columnGap="8px" alignItems="center" margin={`0 0 ${SIZE_8}`}>
      {labels.map((label, index) => {
        const background = LABEL_TO_BACKGROUND_COLOR[label.type];
        const color = LABEL_TO_COLOR[label.type];

        return (
          <UIText3 fontWeight="bold" key={index}>
            <Label background={background} color={color}>
              {label.text}
            </Label>
          </UIText3>
        );
      })}
    </Container>
  );
};
